module.exports = __webpack_public_path__ + "img/52114119_L.87f9cb93.png";